<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :has-form="true" title="离线设备总览"
      width="50%" class="my-test-class" @cancel="closeShow" @confirm="handleConfirm" top="14vh">
      <div style="width: 100%;height: 500px;">
        <el-table size='mini' :data="tableData"
          :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }"
          style="width: 100%;margin-top:15px">
          <el-table-column prop="type" label="类型" align="center">
          </el-table-column>
          <el-table-column prop="offLine" label=离线数量 align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <span style="color: #FF9502;cursor: pointer;font-size: 12px;"
                @click="showDesc(scope.row.fullName)">详情</span>
              <!-- <i class="el-icon-s-tools" @click="updateTime(scope)"></i>
                      <i style="margin-left:20px" class="el-icon-delete-solid" @click="delTime(scope)"></i> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </gs-modal>
    <gs-modal v-loading="loadingdevice" v-model="visibleDecice" :before-close="beforeDeviceClose" :has-form="true"
      title="离线设备" width="50%" class="my-test-class" @cancel="closeDeviceShow" @confirm="handleConfirmDevice"
      top="14vh">
      <!-- 外层容器 -->
      <div style="width: 100%; height: 515px; overflow-y: auto;">
        <!-- 空数据展示 -->
        <div v-if="deviceShow" class="dev-blank">
          <el-empty description="暂无数据"></el-empty>
        </div>
        <!-- 列表数据展示 -->
        <div v-if="!deviceShow" class="dev-line" v-for="(item, index) in deviceArray" :key="index">
          {{ item }}
        </div>
      </div>
    </gs-modal>

  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import service from '../../service/leftService.js'
export default {
  data() {
    return {
      params: {
        pageSize: 5,
        pageNum: 1
      },
      tableData: [
      ],
      loading: false,
      visible: false,
      loadingdevice: false,
      visibleDecice: false,
      deviceArray: [],
      deviceShow: true
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
    handleConfirm() {
      this.visible = false
    },
    beforeClose() {
      this.visible = false
    },
    getData() {
      service.offLineData().then(res => {
        this.tableData = res
      })
    },
    closeShow() {

    },
    // 获取展示的数据
    getShowData() {
      this.visible = true
      this.getData()
    },
    showDesc(val) {
      val.length == 0 ? this.deviceShow = true : this.deviceShow = false
      this.visibleDecice = true
      this.deviceArray = val
    },
    beforeDeviceClose() {
      this.visibleDecice = false
    },
    closeDeviceShow() {
      this.visibleDecice = false
    },
    handleConfirmDevice() {
      this.visibleDecice = false
    }
  }
}
</script>
<style lang='scss'>
.dev-line {
  width: 100%;
  padding: 5px 5px;
  margin-bottom: 5px;
  color: rgb(241, 64, 58);
  font-size: 13px;
  font-weight: 600;
}

.dev-blank {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceList/offLineDevice.vue